import * as React from "react";
import { DefaultNodeModel, DiagramEngine, AbstractNodeFactory } from "storm-react-diagrams";
import { CustomNodeWidget } from "./CustomNodeWidget";
/**
 * See https://github.com/projectstorm/react-diagrams/blob/master/src/defaults/factories/DefaultNodeFactory.ts
 */
export class CustomNodeFactory extends AbstractNodeFactory<DefaultNodeModel> {
  constructor() {
    super("custom");
  }

  generateReactWidget(
    diagramEngine: DiagramEngine,
    node: DefaultNodeModel
  ): JSX.Element {
    return React.createElement(CustomNodeWidget, {
      node: node,
      diagramEngine: diagramEngine
    });
  }

  getNewInstance(initialConfig?: any): DefaultNodeModel {
    return new DefaultNodeModel();
  }
}



// WEBPACK FOOTER //
// ./src/designer/widgets/CustomNodeWidgetFactory.tsx